import Vue from 'vue';
import './plugins/environments';
import './plugins/ant-design';
import './plugins/moment';
import './plugins/axios';
import './plugins/codemirror';
import Sentry from './plugins/sentry';
import './plugins/mixpanel';
import './plugins/sso';
import auth from './plugins/auth';
import i18n from './plugins/i18n';
import App from './App.vue';
import router from './plugins/vue-router';
import store from './store';
import unitConverter from './plugins/unit-converter';
import Observer from './plugins/observer';

import utilities from './plugins/utilities';
import '@videsk/monitor-ui';

const Chrome = require('vue-color/src/components/Chrome.vue');

require('./assets/css/override.css');

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['videsk-monitor'];
Vue.prototype.$Sentry = Sentry;
Vue.prototype.$authorization = auth;
Vue.prototype.$JWTDecode = JWT => JSON.parse(atob(JWT.split('.')[1]));
Vue.prototype.$droppable = null;
Vue.prototype.$utils = utilities;
Vue.prototype.$unitConverter = unitConverter;
Vue.prototype.$Observer = Observer;
Vue.prototype.$convertDate = (datetime) => {
  const timestamp = datetime.split('T')[0];
  return new Date(timestamp);
};
Vue.prototype.$monitor = {
  open: () => document.dispatchEvent(new CustomEvent('monitor', { detail: { open: true } })),
  close: () => document.dispatchEvent(new CustomEvent('monitor', { detail: { open: false } })),
};

Vue.prototype.$urls = {
  searchParams(stringParams) {
    const params = new URLSearchParams(stringParams);
    return [...params.entries()].reduce((accumulator, [key, value]) => {
      accumulator[key] = value;
      return accumulator;
    }, {});
  },
  fullPathName(fullURL) {
    const url = new URL(fullURL || window.location.href);
    return `${url.pathname}${url.search}`;
  }
};

new Vue({
  components: {
    ColorPicker: Chrome,
  },
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
